module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2015/december-0263eb21737cfcd996daf7b8a87c5f89.png";